export default __webpack_public_path__ + "static/1_25-aee1f6559903908b618ec41b75ba070a.png";